const navigationLinks = [
  {
    label: 'Pagina iniziale',
    url: '/',
    altText: 'Case e appartamenti in vendita – Annunci immobiliari - Casa.it',
    mobile: true,
    desktop: false,
    isNew: false,
    isBold: false,
  },
  {
    label: 'Pubblica annuncio gratis',
    url: '/pubblica-annunci',
    altText: 'Pubblica annuncio gratis',
    mobile: true,
    desktop: false,
    isNew: false,
    isBold: false,
  },
  {
    label: 'Valuta la tua casa',
    url: '/valutazione-immobile/',
    altText: 'Valutazione immobiliare Casa.it - Il valore della tua Casa',
    mobile: true,
    desktop: true,
    isNew: false,
    isBold: false,
    isFirstDsk: true,
  },
  {
    label: 'Vendi casa',
    url: '/trova-agenzia/',
    altText: 'Trova le migliori agenzie per vendere casa',
    mobile: true,
    desktop: true,
    isNew: false,
    isBold: false,
  },
  {
    label: 'Trova agenzia',
    url: '/agenzie/',
    altText: 'Agenzie Immobiliari, cerca l\'agenzia più vicina a te su Casa.it',
    mobile: true,
    desktop: true,
    isNew: false,
    isBold: false,
  },
  {
    label: 'Blog',
    url: 'https://blog.casa.it',
    altText: 'Il blog di Casa.it: il punto di riferimento per chi cerca, trova e vive la casa',
    mobile: true,
    desktop: true,
    isNew: false,
    isBold: false,
  },
  {
    label: 'Servizi',
    url: '/casait/servizi/',
    altText: 'Servizi',
    mobile: true,
    desktop: true,
    isNew: false,
    isBold: false,
  },
];
export default navigationLinks;
